import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import FichaPGRS from './FichaPGRS';
import NovoPGRS from './NovoPGRS';
import TextField from '../../components/TextField/TextField';
import { useNavigate } from 'react-router-dom';

//Contants
import { actionsTable } from '../../constants/MaterialTable';

//Helpers
import { showMessage } from '../../helpers/message';
import { objCampo, validarCampos } from '../../helpers/ValidadorDeCampos';
import mascaras from '../../helpers/mascaras';

//Api
import pgrs_api from '../../api/pgrs_api';

//Context
import { useAuth } from '../../context/auth';


function initialStateFiltroPGRS() {
    return {
        cnpj: ""
    }
}

export default function PGRS() {
    const { session, setLoading } = useAuth();

    //Estado de controle para exibição da tela de ficha do pgrs
    const [ficha, setFicha] = useState(null);

    const navigate = useNavigate();

    const [impressaoFicha, setImpressaoFicha] = useState(false);

    const [novo, setNovo] = useState(false);

    const [listPGRS, setListPGRS] = useState([]);

    //Estado para filtros
    const [filtros, setFiltros] = useState(initialStateFiltroPGRS());

    //Estado de controle dos erros nos campos dos filtros
    const [errors, setErrors] = useState({});

    //Estado que controla a visualização dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Troca de estado de visualização dos filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    //Campos de validação do filtros
    const camposfiltros = [ ]

    //Cabeçalhos da tabela de listagem de PGRS
    const [headersTabela, setHeadersTabela] = useState([
        { value: "Identificacao do PGRS", objectValue: "identificacao", align: "left", },
        { value: "Status Analise", objectValue: "statusAnalise", align: "left" }
    ]);

    //Opções do select de status
    const optionsStatus = [
        { value: "", text: "Todos" },
        { value: "Aguardando Análise", text: "Aguardando Análise" },
        { value: "Aprovado", text: "Aprovado" },
        { value: "Aprovado Automaticamente", text: "Aprovado Automaticamente" },
        { value: "Pendente", text: "Pendente" },
        { value: "Reprovado", text: "Reprovado" },
    ]

    function loadPGRSGerador(filtros) {
        setLoading(true)
        pgrs_api.GetListPGRS(filtros)
            .then(response => { 
                response.data = response.data.map(value => {
                    value.cpfcnpj = !!value.cpfcnpj ?  mascaras.cpfcnpjMask(value.cpfcnpj) : ""
                    return value
                })
                setListPGRS(response.data);
             })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }

    //Variavel que guarda as ações da tabela
    const actions = [
        actionsTable.visualizar((item) => setFicha(item.id)), 
        actionsTable.imprimir((item) => {
            setImpressaoFicha(true)
            setFicha(item.id)
            gravarLogImpressao(item.id)
        })
    ];

    //Função de onChange dos filtros do mapa
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;

        const _filtros = { ...filtros, [name]: value };
        const campo = camposfiltros.filter(c => c.name === name);

        const erros = validarCampos(_filtros, campo);

        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else
            setErrors({ ...errors, ...erros[0] });

        setFiltros(_filtros)
    }

    function loadFiltrosPGRS() {
        const erros = validarCampos(filtros, camposfiltros);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        }

        const _filtros = { ...filtros }

        loadPGRSGerador(_filtros)
    }

    useEffect(() => {
        if (session && session.acesso?.sigla == "GS") {
            setHeadersTabela([
                { value: "Identificacao do PGRS", objectValue: "identificacao", align: "left" },
                { value: "Razão Social", objectValue: "razaoSocial", align: "left" },
                { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
                { value: "Status Analise", objectValue: "statusAnalise", align: "left" }
            ]);
        }
        loadPGRSGerador(filtros);
    }, []);

    //Controle da exibição da tela de novo cadastro
    if (novo) {
        return <NovoPGRS
            btnVoltar={() => {
                loadPGRSGerador(filtros);
                setNovo(false);
                setFicha(null)
            }}
            pgrsItem={null}
        />
    }

    //Controle da exibição da tela de ficha
    if (ficha) {
        return <FichaPGRS
            btnVoltar={() => {
                loadPGRSGerador(filtros);
                setFicha(null);
                setNovo(false);
                setImpressaoFicha(false);
            }}
            id={ficha}
            impressaoFicha={impressaoFicha}
        />
    }

    const gravarLogImpressao = (pgrs_id) => {
        setLoading(true)
        pgrs_api.PostLogImpressao(pgrs_id)
            .then()
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }


    return (
        <MainCard
            noCard
            title={"PGRS"}
            btnCadastro={session?.acesso?.sigla == "GS" ? "" : "Adicionar"}
            btnVoltarInTop={() => navigate(-1)}
            onClickBtnCadastro={session?.acesso?.sigla == "GS" ? null : () => setNovo(true)}
            btnFiltros={session?.acesso?.sigla == "GS" ? toggleFiltros : null}
        >
            <div className={`filtros ${openFiltros ? "" : "close"}`} id={"filtros"}>
                <Row>
                    <Col md="12" lg="4">
                        <TextField
                            label="CNPJ do Gerador"
                            name="cnpj"
                            maxLength={18}
                            mask={mascaras.cpfcnpjMask}
                            value={filtros.cnpj}
                            invalid={errors.cnpj}
                            onChange={onChangeFiltros}
                        />
                    </Col>
                    <Col sm="12" md="6" lg="4">
                        <TextField name="status" label={"* Status"} type={"select"} value={filtros.status} invalid={!!errors.status} onChange={onChangeFiltros} options={optionsStatus} />
                    </Col>
                    <Col md="12" lg="4" className='m-0 mt-4 py-1'>
                        <Button
                            color='primary'
                            onClick={loadFiltrosPGRS}
                        >
                            <FontAwesomeIcon icon={faSearch} /> Pesquisar
                        </Button>
                    </Col>
                </Row>
            </div>

            <div className={`w-100 `}>
                <div className='mt-4'>
                    <TabelaListagem
                        headers={headersTabela}
                        items={listPGRS}
                        actions={actions}
                        title="Lista de PGRS"
                        options={{ print: false, search: true, pagination: true }}
                    />
                </div>
            </div>
        </MainCard >
    )
}
